// Cakeのview(.ctp)からも呼ばれるのでグローバルで定義
global.$          = require('jquery');
global.jQuery     = global.$;
global._          = require('underscore');
global.Backbone   = require('backbone');
global.Handlebars = require('../handlebars-require');

// @todo キャンペーンが重くて落ちるので require('jquery-ui');
require('fancybox')($);
require('slick-carousel');

// Appの定義
global.App = require('namespace');
require('util')();

App.Templates   = require('template');
App.Models      = require('model');
App.Collections = require('collection');
App.Views       = require('view');
App.Inits       = require('spInit');

/* Sentry https://docs.getsentry.com/hosted/clients/javascript/ */
if (window.Raven) {
  (function() {
    var user_config;
    Raven.config('https://8caed48ac8664b1894930e7e5999c9ed@app.getsentry.com/34688', {
      whitelistUrls: [/\/js\/sp\/all\.min\.js/], // all.min.jsのみを対象に
      shouldSendCallback: function(data) {
        // 発生箇所を特定できていないエラーは計測対象外とする
        if (!data.culprit || data.culprit.indexOf('<unknown module>') > -1) {
          return false;
        }
        return true;
      }
    }).install();

    user_config = {
      is_login: _.has(App, 'me') ? App.me.is_login : false
    };
    if (user_config.is_login) {
      user_config = App.me;
      // Sentryに渡さない項目
      delete user_config.token;
      delete user_config.User.uuid;
      // 以下の項目は設定の有無だけ記録する
      _.each(['aws_endpoint_arn', 'address', 'email', 'phone_number'], function(field) {
        var is_set;
        is_set                     = Boolean(user_config['User'][field]);
        user_config['User'][field] = is_set;
      });
    }
    Raven.setUserContext(user_config);

    $(document).ajaxError(function(event, jqXHR, ajaxSettings, thrownError) {
      Raven.captureMessage(thrownError || jqXHR.statusText, {
        extra: {
          type: ajaxSettings.type,
          url: ajaxSettings.url,
          data: decodeURI(ajaxSettings.data).split('&'), // 厳密にパースする必要もないが、keyごとに区切ることで少しだけ読みやすくしておく
          status: jqXHR.status,
          error: thrownError || jqXHR.statusText,
          response: jqXHR.responseText.substring(0, 100)
        },
        logger: 'ajax-error',
      });
    });
  })();
}

//$.ajax関数の設定
$.ajaxSetup({
  dataType: 'json',
  timeout: 40000
});

$(document).ajaxStart(function (){
  $(".loading-gif").show();
});

$(document).ajaxStop(function (){
  $(".loading-gif").hide();
});

$(function(){
  if (App.me.is_login) {
    // Mixpanel
    mixpanel.identify(App.me.User.id);
  }
  // initメソッドを呼び出す
  if (!_.isEmpty(App.init_fn) && _.has(App.Inits, App.init_fn.controller) && _.has(App.Inits[App.init_fn.controller], App.init_fn.action)) {
      // App.varsを深いコピーして,参照渡しする。
      App.Inits[App.init_fn.controller][App.init_fn.action].call(App.Inits[App.init_fn.controller], App.vars);
  }

  // アプリバナーイベントのバインド
  new App.Views.AppBannerClose();

  // varsはスコープが広すぎるので、初期化関数に渡したら消す
  //App.vars = null;

  // headerのScrollOnFixed(WebMobileのみ)
  if (!App.me.is_app) {
    const header = $('.header')
    const contents = $('.wrapper')
    const fixedClass = 'is-fixed'
    const headerHeight = header.outerHeight()
    const headerPos = header.offset().top
    $(window).on('load scroll', function() {
      let value = $(this).scrollTop()
      if (value > headerPos) {
        header.addClass(fixedClass)
        contents.css('margin-top', headerHeight)
      } else {
        header.removeClass(fixedClass)
        contents.css('margin-top', '0')
      }
    })
  }
});



// WEBPACK FOOTER //
// ./webroot/js/sp/app.js